import { Button, Stack, Typography } from "@mui/material";
import { AddSquare } from "iconsax-react";
import ServersTabsComponent from "../../components/panel/severs/ServersTab";
import AddNewServerModal from "../../components/panel/severs/add-new-server-modal/AddNewServer";
import { useState } from "react";
import { useCanAccess } from "../../hooks/canAccess";
import { AccessEnums } from "../../constants/accessEnum";
import MuiBaseModal from "../../components/common/modal/MuiModal";
import AddNewServerForm from "../../forms/add-new-server/AddNewServerForm";
import { useLangContext } from "../../context/langContext";
import compInfos from "../../components/panel/severs/add-new-server-modal/add-new-server.json";
export default function ServersPage() {
  const [openModal, setOpenModal] = useState(false);
  const { can } = useCanAccess();
  const { lang } = useLangContext();
  const infos = compInfos[lang];
  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "8px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={({ palette }) => palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                سرور ها
              </Typography>
              <Typography
                variant="footerDemiBold"
                color={({ palette }) => palette.complement[300]}
                sx={{
                  mb: "20px",
                }}
              >
                لیست سرور ها
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
              mb={{ xs: "16px", md: "initial" }}
            >
              <Button
                disabled={!can(AccessEnums.AdminPbxServersCreate)}
                onClick={() => setOpenModal(true)}
                variant="contained"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <AddSquare size="20" />
                ایجاد سرور جدید
              </Button>
            </Stack>
          </Stack>
          <ServersTabsComponent />
        </Stack>
      </Stack>
      <AddNewServerModal
        openModal={openModal}
        handleReload={() => {console.log('reload component ');
        }}
        onClose={() => setOpenModal(false)}
      />
    </>
  );
}
